/**
 * Interfaz que define todas las claves de traducción del componente Alta Solicitudes.
 * Cualquier omisión generará error de compilación.
 * Fecha: 27/06/2025
 */
export interface ILabelsAltaSolicitudes {
  empresa: string;
  proveedor: string;
  moneda: string;
  fechaDeOperacion: string;
  todas: string;
  seleccionarPagina: string;
  totalAOperar: string;
  porcentaje: string;
  buscar: string;
  facturasSeleccionadas: string;
  total: string;
  calcular: string;
  simular: string;
  empresaInfo: string;
  proveedorInfo: string;
  monedaInfo: string;
  fechaDeOperacionInfo: string;
  numeroDeFactura: string;
  fechaFactura: string;
  fechaDeVencimiento: string;
  simuladorCostoFinanciero: string;
  fechaDeOperacionSim: string;
  vencimientoDeOperacion: string;
  valor100Documento: string;
  importeRealFactoraje: string;
  interesesADescontar: string;
  ivaIntereses: string;
  comision: string;
  ivaComision: string;
  efectivoNeto: string;
  autorizadoPor: string;
  verDetalles: string;
  confirmar: string;
  detalles: string;
  seleccionaEmpresa: string;
  seleccionaProveedor: string;
  // Modal detallado
  uuid: string;
  tasaInterbancaria: string;
  tasaComision: string;
  tasaInterna: string;
  tasaTotal: string;
  intereses: string;
  comisionTotal: string;
  costoFinanciero: string;
  diasDescuento: string;
  interes: string;
  ivaDelInteres: string;
  comisionCol: string;
  ivaDeLaComision: string;
  // Modal no detallado
  montoFactura: string;
  tasaDescuento: string;
  comisionApertura: string;
  comisionOperacion: string;
  montoDescontado: string;
  montoARecibir: string;
  // Columna tabla principal
  estatus: string;
  // Mensajes SweetAlert
  swalCargandoInfo: string;
  swalServicioNoDisponible: string;
  swalErrorConsultarMoneda: string;
  swalNoFacturasPendientes: string;
  swalErrorConsultarInfo: string;
  swalSeleccioneCadena: string;
  swalSeleccioneFactura: string;
  swalCargando: string;
  swalCreandoSolicitud: string;
  swalErrorCrearSolicitud: string;
  swalSolicitudExitosa: string;
  swalHoraLimite: string;
  swalOcurrioError: string;
}

/**
 * Tipo que define los idiomas soportados por el diccionario de traducciones.
 */
export type IdiomaDisponible = 'es' | 'en';

/**
 * Diccionario de traducciones para el componente Alta Solicitudes.
 * Contiene las traducciones completas en español e inglés.
 * Fecha: 27/06/2025
 */
export const LABELS_ALTA_SOLICITUDES: Record<IdiomaDisponible, ILabelsAltaSolicitudes> = {
  es: {
    empresa: 'Empresa',
    proveedor: 'Proveedor',
    moneda: 'Moneda',
    fechaDeOperacion: 'Fecha de operación',
    todas: 'Todas',
    seleccionarPagina: 'Seleccionar página',
    totalAOperar: 'Total a operar',
    porcentaje: 'Porcentaje',
    buscar: 'Buscar...',
    facturasSeleccionadas: 'factura(s) seleccionada(s)',
    total: 'TOTAL',
    calcular: 'Calcular',
    simular: 'Simular',
    empresaInfo: 'Empresa:',
    proveedorInfo: 'Proveedor:',
    monedaInfo: 'Moneda:',
    fechaDeOperacionInfo: 'Fecha de operación:',
    numeroDeFactura: 'Número de factura',
    fechaFactura: 'Fecha factura',
    fechaDeVencimiento: 'Fecha de vencimiento',
    simuladorCostoFinanciero: 'Simulador Costo Financiero Cliente',
    fechaDeOperacionSim: 'Fecha de Operación:',
    vencimientoDeOperacion: 'Vencimiento de Operación:',
    valor100Documento: 'Valor 100% del Documento:',
    importeRealFactoraje: 'Importe Real Factoraje:',
    interesesADescontar: 'Intereses a Descontar:',
    ivaIntereses: 'IVA de los intereses:',
    comision: 'Comisión:',
    ivaComision: 'IVA de la Comisión:',
    efectivoNeto: 'Efectivo Neto:',
    autorizadoPor: 'Autorizado por:',
    verDetalles: 'Ver detalles',
    confirmar: 'Confirmar',
    detalles: 'Detalles',
    seleccionaEmpresa: 'Selecciona una empresa',
    seleccionaProveedor: 'Selecciona un proveedor',
    uuid: 'UUID',
    tasaInterbancaria: 'Tasa interbancaria',
    tasaComision: 'Tasa comisión',
    tasaInterna: 'Tasa interna',
    tasaTotal: 'Tasa total',
    intereses: 'Intereses',
    comisionTotal: 'Comisión total',
    costoFinanciero: 'Costo financiero',
    diasDescuento: 'Días descuento',
    interes: 'Interes',
    ivaDelInteres: 'iva del interes',
    comisionCol: 'Comision',
    ivaDeLaComision: 'iva de la comision',
    montoFactura: 'Monto de factura',
    tasaDescuento: 'Tasa descuento',
    comisionApertura: 'Comisión por apertura',
    comisionOperacion: 'Comisión por operación',
    montoDescontado: 'Monto descontado',
    montoARecibir: 'Monto a recibir',
    estatus: 'Estatus',
    swalCargandoInfo: 'Cargando información',
    swalServicioNoDisponible: 'El servicio de factoraje no está disponible',
    swalErrorConsultarMoneda: 'Ocurrio un error al consultar la moneda',
    swalNoFacturasPendientes: 'No se encontraron facturas pendientes de descontar',
    swalErrorConsultarInfo: 'Ocurrio un error al consultar la información',
    swalSeleccioneCadena: 'Seleccione una cadena válida',
    swalSeleccioneFactura: 'Debe seleccionar al menos una factura',
    swalCargando: 'Cargando',
    swalCreandoSolicitud: 'Creando la solicitud, por favor espere',
    swalErrorCrearSolicitud: 'Ocurrio un error al crear la solicitud',
    swalSolicitudExitosa: 'Creacion de Solicitud Exitosa, presione OK para continuar',
    swalHoraLimite: 'La hora límite para hacer solicitudes de factoraje es:',
    swalOcurrioError: 'Ocurrio un error',
  },
  en: {
    empresa: 'Company',
    proveedor: 'Supplier',
    moneda: 'Currency',
    fechaDeOperacion: 'Operation date',
    todas: 'All',
    seleccionarPagina: 'Select page',
    totalAOperar: 'Total to operate',
    porcentaje: 'Percentage',
    buscar: 'Search...',
    facturasSeleccionadas: 'invoice(s) selected',
    total: 'TOTAL',
    calcular: 'Calculate',
    simular: 'Simulate',
    empresaInfo: 'Company:',
    proveedorInfo: 'Supplier:',
    monedaInfo: 'Currency:',
    fechaDeOperacionInfo: 'Operation date:',
    numeroDeFactura: 'Invoice number',
    fechaFactura: 'Invoice date',
    fechaDeVencimiento: 'Due date',
    simuladorCostoFinanciero: 'Client Financial Cost Simulator',
    fechaDeOperacionSim: 'Operation Date:',
    vencimientoDeOperacion: 'Operation Due Date:',
    valor100Documento: '100% Document Value:',
    importeRealFactoraje: 'Actual Factoring Amount:',
    interesesADescontar: 'Interest to Discount:',
    ivaIntereses: 'VAT on interest:',
    comision: 'Commission:',
    ivaComision: 'VAT on Commission:',
    efectivoNeto: 'Net Cash:',
    autorizadoPor: 'Authorized by:',
    verDetalles: 'View details',
    confirmar: 'Confirm',
    detalles: 'Details',
    seleccionaEmpresa: 'Select a company',
    seleccionaProveedor: 'Select a supplier',
    uuid: 'UUID',
    tasaInterbancaria: 'Interbank rate',
    tasaComision: 'Commission rate',
    tasaInterna: 'Internal rate',
    tasaTotal: 'Total rate',
    intereses: 'Interests',
    comisionTotal: 'Total commission',
    costoFinanciero: 'Financial cost',
    diasDescuento: 'Discount days',
    interes: 'Interest',
    ivaDelInteres: 'VAT on interest',
    comisionCol: 'Commission',
    ivaDeLaComision: 'VAT on commission',
    montoFactura: 'Invoice amount',
    tasaDescuento: 'Discount rate',
    comisionApertura: 'Opening commission',
    comisionOperacion: 'Operation commission',
    montoDescontado: 'Discounted amount',
    montoARecibir: 'Amount to receive',
    estatus: 'Status',
    swalCargandoInfo: 'Loading information',
    swalServicioNoDisponible: 'The factoring service is not available',
    swalErrorConsultarMoneda: 'An error occurred while retrieving the currency',
    swalNoFacturasPendientes: 'No pending invoices found for discounting',
    swalErrorConsultarInfo: 'An error occurred while retrieving the information',
    swalSeleccioneCadena: 'Please select a valid company',
    swalSeleccioneFactura: 'You must select at least one invoice',
    swalCargando: 'Loading',
    swalCreandoSolicitud: 'Creating the request, please wait',
    swalErrorCrearSolicitud: 'An error occurred while creating the request',
    swalSolicitudExitosa: 'Request created successfully, press OK to continue',
    swalHoraLimite: 'The deadline for factoring requests is:',
    swalOcurrioError: 'An error occurred',
  }
};
